/**
 * Centralized translations for AI Editor Screen
 * Contains all labels used in the AI editor component
 */

export const AIEditorLabels = {
    it: {
        // Main labels
        aiEditor: 'Editor AI',
        aiEditorTitle: 'Editor AI - Generazione Contenuti',
        aiEditorDescription: 'Utilizza l\'intelligenza artificiale per creare e modificare documenti',
        
        // Navigation
        backToDashboard: 'Torna alla Dashboard',
        openEditor: 'Apri Editor',
        
        // Editor functionality
        startWriting: 'Inizia a scrivere o usa l\'assistente AI...',
        generateContent: 'Genera Contenuto',
        stopGenerating: 'Ferma Generazione',
        copyText: 'Copia Testo',
        downloadDocx: 'Scarica DOCX',
        undo: 'Annulla',
        redo: 'Ripeti',
        
        // AI Assistant
        aiAssistant: 'Assistente AI',
        describeWhatYouWant: 'Descrivi cosa vuoi creare o modificare:',
        placeholderText: 'Crea un articolo da zero o chiedi di modificare il contenuto...',
        yourAnswer: 'La tua risposta...',
        sendAnswer: 'Invia Risposta',
        recentActivity: 'Attività Recente',
        
        // Status messages
        connecting: 'Connessione...',
        ready: 'Pronto',
        processing: 'Elaborazione...',
        disconnected: 'Disconnesso',
        connectionError: 'Errore di Connessione',
        awaitingInput: 'In Attesa di Input',
        operationCompleted: 'Operazione Completata',
        operationCancelled: 'Operazione Annullata dall\'Utente',
        
        // Grounding
        grounding: 'Grounding',
        configureGroundingFolders: 'Configura Cartelle Grounding',
        selectGroundingFolders: 'Seleziona Cartelle Grounding',
        selectFoldersDescription: 'Seleziona una o più cartelle da utilizzare per il grounding. Queste sovrascriveranno i parametri URL.',
        noGroundingFolders: 'Nessuna cartella grounding disponibile.',
        loadingGroundingFolders: 'Caricamento cartelle grounding...',
        applySelection: 'Applica Selezione',
        cancel: 'Annulla',
        lastUpdated: 'Ultimo aggiornamento:',
        
        // Error messages
        error: 'Errore',
        unknownError: 'Errore sconosciuto',
        editorNotReady: 'Editor non pronto. Attendi e riprova.',
        noContentToExport: 'Nessun contenuto da esportare',
        failedToLoadGroundingFolders: 'Impossibile caricare le cartelle grounding. Riprova.',
        
        // Success messages
        contentGenerated: 'Contenuto generato con successo',
        textCopied: 'Testo copiato!',
        documentDownloaded: 'Documento scaricato con successo'
    },
    
    en: {
        // Main labels
        aiEditor: 'AI Editor',
        aiEditorTitle: 'AI Editor - Content Generation',
        aiEditorDescription: 'Use artificial intelligence to create and modify documents',
        
        // Navigation
        backToDashboard: 'Back to Dashboard',
        openEditor: 'Open Editor',
        
        // Editor functionality
        startWriting: 'Start writing or use the AI assistant...',
        generateContent: 'Generate Content',
        stopGenerating: 'Stop Generating',
        copyText: 'Copy Text',
        downloadDocx: 'Download DOCX',
        undo: 'Undo',
        redo: 'Redo',
        
        // AI Assistant
        aiAssistant: 'AI Assistant',
        describeWhatYouWant: 'Describe what you want to create or modify:',
        placeholderText: 'Create an article from scratch or ask to modify the content...',
        yourAnswer: 'Your answer...',
        sendAnswer: 'Send Answer',
        recentActivity: 'Recent Activity',
        
        // Status messages
        connecting: 'Connecting...',
        ready: 'Ready',
        processing: 'Processing...',
        disconnected: 'Disconnected',
        connectionError: 'Connection Error',
        awaitingInput: 'Awaiting Input',
        operationCompleted: 'Operation Completed',
        operationCancelled: 'Operation Cancelled by User',
        
        // Grounding
        grounding: 'Grounding',
        configureGroundingFolders: 'Configure Grounding Folders',
        selectGroundingFolders: 'Select Grounding Folders',
        selectFoldersDescription: 'Select one or more folders to use for grounding. These will override any URL parameters.',
        noGroundingFolders: 'No grounding folders available.',
        loadingGroundingFolders: 'Loading grounding folders...',
        applySelection: 'Apply Selection',
        cancel: 'Cancel',
        lastUpdated: 'Last updated:',
        
        // Error messages
        error: 'Error',
        unknownError: 'Unknown error',
        editorNotReady: 'Editor not ready. Please wait and try again.',
        noContentToExport: 'No content to export',
        failedToLoadGroundingFolders: 'Failed to load grounding folders. Please try again.',
        
        // Success messages
        contentGenerated: 'Content generated successfully',
        textCopied: 'Text copied!',
        documentDownloaded: 'Document downloaded successfully'
    }
};

